/** @jsx jsx */
import { jsx, Box, Text, Avatar } from "theme-ui"
import { Participant as ParticipantType } from "../../types"
import { Tooltip } from "components/Tooltip"
import * as styles from "./styles"
import React from "react"

interface ParticipantProps {
  className?: string
  participant: ParticipantType
}

export const Participant: React.FC<ParticipantProps> = ({
  className,
  participant,
}) => {
  const { user, role } = participant
  return (
    <Box sx={styles.root} className={className}>
      <Avatar src={user.avatarUrl} sx={styles.avatar} />
      <Box>
        <Text variant="small" sx={styles.name}>
          {user.realName}
        </Text>
        <Tooltip
          content={role.description}
          sx={styles.tooltip}
          placement="bottom"
        >
          <Text variant="micro" sx={styles.roleName}>
            {role.name}
          </Text>
        </Tooltip>
      </Box>
    </Box>
  )
}
